import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';
import { BaseApi } from '@/shared/api/baseApi';
import type { PaginatedResponse } from '@/shared/types/entity';
import type { DeepLink, DeepLinkFormData, DeepLinkOptions } from '../types';

type DeepLinksListParams = {
  page?: number;
  perPage?: number;
  routingCode?: string;
  targetSystem?: string;
  isActive?: boolean;
};

type SkipLoaderConfig = {
  params?: DeepLinksListParams;
  skipLoader: boolean;
};

const deepLinksApiInstance = new BaseApi<DeepLink, DeepLinkFormData>(API_ENDPOINTS.DEEP_LINKS);

export const deepLinksApi = {
  getOptions: async (): Promise<DeepLinkOptions> => {
    const response = await api.get<DeepLinkOptions>(API_ENDPOINTS.DEEP_LINKS.OPTIONS, {
      skipLoader: true,
    } as SkipLoaderConfig);
    return response.data;
  },
  getList: async (params?: DeepLinksListParams): Promise<PaginatedResponse<DeepLink>> => {
    const response = await api.get<PaginatedResponse<DeepLink>>(API_ENDPOINTS.DEEP_LINKS.LIST, {
      params,
      skipLoader: true,
    } as SkipLoaderConfig);
    return response.data;
  },
  getOne: deepLinksApiInstance.getOne.bind(deepLinksApiInstance),
  create: deepLinksApiInstance.create.bind(deepLinksApiInstance),
  update: deepLinksApiInstance.update.bind(deepLinksApiInstance),
  delete: deepLinksApiInstance.delete.bind(deepLinksApiInstance),
};
